import script from "./LoadingOverlay.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoadingOverlay.vue?vue&type=script&lang=ts&setup=true"

import "./LoadingOverlay.vue?vue&type=style&index=0&id=719f5da2&lang=scss&scoped=true"

import exportComponent from "C:\\Dev\\Rhiag_front\\RhiagFrontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-719f5da2"]])

export default __exports__